import Component from './InstagramAnalyticsPublic.vue'
export default Component
